import React from 'react';
import Flatpickr from 'react-flatpickr';
import moment from 'moment-timezone/builds/moment-timezone-with-data-2012-2022.min';
import { ErrorMessage, Field } from 'formik';
import useFieldDecorators from '../hooks/useFieldDecorators';
import Tooltip from '../common/Tooltip';
import './DateField.css';
export const defaultDateFormat = 'YYYY-MM-DD hh:mm A z';
const DateField = (props) => {
    const { isRequired, contentCssClass, labelCssClass, fieldCssClass } = useFieldDecorators(props);
    const clearable = () => {
        if (props.clearable) {
            return (React.createElement("span", { className: "input-group-addon", "data-clear": true },
                React.createElement("span", { className: "far fa-trash-alt pointer", title: "Remove date" })));
        }
        return null;
    };
    const timezone = props.timezone || moment.tz.guess();
    const dateFormat = props.flatpickrProps &&
        props.flatpickrProps.options &&
        props.flatpickrProps.options.dateFormat
        ? props.flatpickrProps.options.dateFormat
        : defaultDateFormat;
    return (React.createElement("div", { className: "form-group row" },
        React.createElement("label", { htmlFor: props.name, className: `${labelCssClass} control-label` },
            isRequired,
            props.label,
            " \u00A0",
            React.createElement(Tooltip, { text: props.tooltip, name: props.name })),
        React.createElement("div", { className: contentCssClass },
            React.createElement(Field, { name: props.name }, ({ field, form }) => (React.createElement(Flatpickr, Object.assign({ "data-enable-time": true }, props.flatpickrProps, { options: Object.assign({ wrap: true, allowInput: false, dateFormat, clickOpens: !props.disabled, defaultDate: moment.tz(field.value, timezone).format(), enableTime: true, minuteIncrement: 10, defaultHour: 12, parseDate(dateString, format) {
                        const timezonedDate = moment.tz(dateString, format, timezone);
                        return new Date(timezonedDate.year(), timezonedDate.month(), timezonedDate.date(), timezonedDate.hour(), timezonedDate.minute(), timezonedDate.second());
                    },
                    formatDate(date, format) {
                        return moment
                            .tz([
                            date.getFullYear(),
                            date.getMonth(),
                            date.getDate(),
                            date.getHours(),
                            date.getMinutes(),
                            date.getSeconds(),
                        ], timezone)
                            .format(format);
                    } }, (props.flatpickrProps ? props.flatpickrProps.options : {})), onChange: (selectedDates, dateString) => {
                    const utcDate = moment
                        .tz(dateString, dateFormat, timezone)
                        .toISOString();
                    if (props.onChange) {
                        props.onChange(utcDate);
                    }
                    form.setFieldValue(props.name, utcDate);
                }, onOpen: () => {
                    form.setFieldTouched(props.name, true);
                }, render: (pickrProps, ref) => (React.createElement("div", { "data-testid": "date-field-wrapper", className: "input-group", ref: ref },
                    React.createElement("div", { className: "input-group-prepend" },
                        React.createElement("div", { className: "input-group-text" },
                            React.createElement("span", { className: "input-group-addon", "data-toggle": true },
                                React.createElement("span", { className: "far fa-calendar-alt pointer" })))),
                    React.createElement("input", { "data-testid": props.testId, type: pickrProps.type, name: field.name, id: field.name, disabled: props.disabled ? true : undefined, className: fieldCssClass, "data-input": true }),
                    clearable())) })))),
            React.createElement(ErrorMessage, { name: props.name, className: "text-danger", component: "small" }))));
};
export default DateField;
